import { render, staticRenderFns } from "./mains.vue?vue&type=template&id=09403e98&scoped=true&"
import script from "./mains.vue?vue&type=script&lang=js&"
export * from "./mains.vue?vue&type=script&lang=js&"
import style0 from "./mains.vue?vue&type=style&index=0&id=09403e98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09403e98",
  null
  
)

export default component.exports